import { createSelector } from 'reselect';

export const getBoxData = (state) => state.box.data;

export const getFolderList = () => createSelector([getBoxData], (folders) => folders.entries);

export const employeeSearchList = createSelector([getBoxData], (employeeData) =>
  employeeData.map((employee) => ({
    value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
    label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
    email: employee.email.toLowerCase(),
    employeeNumber: employee.employeeNumber || 'NA',
  }))
);
